export default function initScrollTo() {
  const buttons = document.querySelectorAll(".scroll-to")

  buttons.forEach((button) => {
    // Prevent double binding
    if (button.dataset.bound === "true") return

    button.dataset.bound = "true"

    button.addEventListener("click", (e) => {
      const header = document.querySelector("header")
      const elementPosition = e.currentTarget.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - 20

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      })
    })
  })
}
